import React from 'react';
import {IconButton, Tooltip} from 'material-ui';
import EditIcon from 'material-ui-icons/Edit';
import {Link} from 'react-router-dom';

const usersGridColumns = [
    {
        id: 'id',
        Header: 'Id',
        accessor: 'id',
        width: 50
    },
    {
        Header: 'Name',
        accessor: 'name'
    },
    {
        Header: 'Username',
        accessor: 'username'
    },
    {
        Header: 'Email',
        accessor: 'email'
    },
    {
        id: 'active',
        Header: 'Active',
        accessor: u => (u.active ? 'Yes' : 'No'),
        width: 100
    },
    {
        Header: 'Actions',
        width: 100,
        sortable: false,
        Cell: props => (
            <span>
                <Link to={'users/' + props.row.id}>
                    <Tooltip title='Edit User Roles, Sites &amp; Languages'>
                        <IconButton className='smallIconButton editColor'>
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                </Link>{' '}
            </span>
        )
    }
];

export default usersGridColumns;



// WEBPACK FOOTER //
// ./src/containers/users/UsersGridColumns.jsx